import { render, staticRenderFns } from "./ProjectSaveEditDialog.vue?vue&type=template&id=b2828542"
import script from "./ProjectSaveEditDialog.vue?vue&type=script&lang=js"
export * from "./ProjectSaveEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectSaveEditDialog.vue?vue&type=style&index=0&id=b2828542&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports